import { State } from '../@types';

export const selectLastKnownLocation = (store: State) =>
  store.device.lastKnownLocation;
export const selectDeviceLanguage = (store: State) => store.device.language;
export const selectDeviceUUID = (store: State) => store.device.deviceUUID;
export const selectFingerprint = (store: State) => store.device.fingerprint;
export const selectDevicePaired = (store: State) =>
  store.device.status.devicePaired;
export const selectDeviceConnected = (store: State) =>
  store.device.status.deviceConnected;
export const selectCameraPermission = (store: State) =>
  store.device.status.cameraPermission;
export const selectLocationPermission = (store: State) =>
  store.device.status.locationPermission;
export const selectIsKeyboardOpened = (store: State) =>
  store.device.isKeyboardOpened;
export const selectBluetoothPermission = (store: State) =>
  store.device.status.bluetoothPermission;
export const selectBluetoothStatus = (store: State) =>
  store.bluetooth.status.bluetoothStatus;

export const selectTotalMemory = (store: State) => store.device.totalMemory;
export const selectUsedMemory = (store: State) => store.device.usedMemory;

export const selectXBrandId = (store: State) => store.config.xBrandId;

export const selectBluetooth = (store: State) => store.bluetooth;
